<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-[#18181B] print:hidden" [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.compact"
    [opened]="!isScreenSmall" [class.fixed-nav]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo (dinâmica quando há white-label) -->
        <div class="mb-2 mt-3 flex h-18 items-center justify-center cursor-pointer" (click)="home()">
            <img class="w-18 max-h-16 object-contain" [src]="logoMenu" alt="Logo" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col bg-[#18181B]" [style.margin-left]="!isScreenSmall ? 'var(--nav-compact-w)' : '0'">
    <!-- Header -->
    <div
        class="bg-[#18181B] relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button (mobile only) -->
        @if (isScreenSmall) {
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-6">
            <button *ngIf="showBadge" mat-icon-button class="badge-tight" (click)="verComunicados()" [matBadge]="unreadCount"
                [matBadgeHidden]="!unreadCount" matBadgeSize="small" matBadgeColor="warn" matBadgePosition="above after"
                [matBadgeOverlap]="true" matTooltip="Comunicados" matTooltipPosition="below">
                <mat-icon class="text-white" svgIcon="heroicons_outline:megaphone"></mat-icon>
            </button>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col bg-[#18181B]">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer "Powered by Edduca Imob" — só quando há white-label ativo -->
    <app-footer-powered></app-footer-powered>
</div>